import { makeImageSrcSelector } from "@client/content/selectors";
import { type RootContainerProps } from "@client/content/types";
import { connectCustom } from "@client/lib/misc";
import { getSettingValueSelector, TargetSelector } from "@client/selectors";
import { type AppState } from "@client/types";
import Component, { type ImageComponentProps } from "./component";

const makeMapStateToProps = () => {
  const imageSrcSelector = makeImageSrcSelector(TargetSelector.Entity, "src", "image");
  const altSelector = getSettingValueSelector(TargetSelector.Entity, "alt", "image");

  return (state: AppState, props: RootContainerProps): ImageComponentProps => {
    return {
      ...props,
      imageSrc: imageSrcSelector(state, props),
      alt: altSelector(state, props)
    };
  };
};

export default connectCustom(makeMapStateToProps)(Component);
